import emotionTheme from '@/styles/theme'
import { THRESHOLD } from '@/resources/enums/performance'

export const getThreshold = operationalIncentive => {
  const achievedKpiTarget = operationalIncentive?.kpiLevels?.[0].achieved

  if (!operationalIncentive) return THRESHOLD.DEFAULT
  if (achievedKpiTarget) return THRESHOLD.SUCCESS

  return THRESHOLD.DANGER
}

export const getThresholdOldColorRule = (thresholdValues, value) => {
  if (!thresholdValues || !value) return THRESHOLD.DEFAULT
  if (value <= thresholdValues[0]) return THRESHOLD.DANGER
  if (value <= thresholdValues[1]) return THRESHOLD.WARNING

  return THRESHOLD.SUCCESS
}

export const THRESHOLD_COLORS = {
  DEFAULT: emotionTheme.ds.ColorBaseGreyLevel4,
  DANGER: '#E00707',
  WARNING: '#826800',
  SUCCESS: '#008C1F',
}

export const thresholdLimits = {
  fillRate: [90.2, 94.9, 95],
  orderRating: [4.55, 4.79, 4.8],
  tenMinutesDeliveryReleaseRate: [85.4, 89.9, 90],
  deliveryTrackingAccuracyRate: [90.2, 94.9, 95],
  idealPortfolioRate: [85.4, 89.9, 90],
  availabilityRate: [90.2, 94.9, 95],
}

export const alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]
